import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';

import { environment } from '../environments/environment';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BaseService } from './shared';
import { LucideAngularModule, Heart, Info, Plus, RotateCcw, Minus, Calendar, MapPin, Armchair, DoorOpen, ChevronLeft } from 'lucide-angular';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    environmentName = '';
    environmentUrl = '';
    userActivity;
    userInactive: Subject<any> = new Subject();
    unsubscribeAll$ = new Subject<void>();

    constructor(
        routeActivate: ActivatedRoute,
        private router: Router,
        private idle: Idle,
        private keepalive: Keepalive,
        private baseService: BaseService
    ) {
        let returnUrl = window.location.href;
        if (returnUrl.indexOf('code=') > 0) {
            this.environmentName = environment.environmentName;
            this.environmentUrl = environment.appUrl;
            let startIndex = returnUrl.indexOf('code=') + 5;
            let endIndex = returnUrl.indexOf('&');
            let code = returnUrl.substr(startIndex, endIndex - startIndex);
            localStorage.setItem('gmail_code', code);
            let gmail_source = localStorage.getItem('gmail_source');
        }

        idle.setIdle(environment.timeoutMinutes * 60);

        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleStart.subscribe(() => this.router.navigate(['login']));

        this.reset();

        //this.setTimeout();
        //this.userInactive.subscribe(() => this.router.navigate(['login']));
    }

    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }

    // setTimeout() {
    //   this.userActivity = setTimeout(() => this.userInactive.next(undefined), environment.timeoutMinutes * 60 * 1000);
    // }

    // @HostListener('window:mousemove') refreshUserState() {
    //   clearTimeout(this.userActivity);
    //   this.setTimeout();
    // }

    ngOnInit() {
        this.baseService.finishedLoadingTranslation
            .pipe(take(2), takeUntil(this.unsubscribeAll$))
            .subscribe((value) => {
                if (value) {
                    const spinnerDiv = document.getElementById('loader-till-translate');
                    spinnerDiv.classList.add('d-none');
                    console.log(spinnerDiv);
                }
            });
        // let returnUrl=window.location.href;
        // if(returnUrl.indexOf('code')>0){
        //   let startIndex=returnUrl.indexOf('code')+5
        //   let endIndex=returnUrl.indexOf('&')
        //   let urlEndIndex=returnUrl.indexOf('?')
        //   let code=returnUrl.substr(startIndex,endIndex-startIndex)
        //   let url=returnUrl.substr(0,urlEndIndex-1)
        //   let body={code:code,url:url}
        //   localStorage.setItem('oauthToken', code);

        //     this.cmsService.saveCode(body).subscribe(result => {

        //        if(result)this.router.navigate['cms-inbox']
        //      })
        //     }

        //   this.route.queryParamMap.subscribe(queryParams => {
        //     console.log(queryParams)
        //  if(queryParams){
        //     //post code
        //     var code= queryParams.get("code");
        //     this.cmsService.saveCode(code).subscribe(result => {
        //          if(result)this.router.navigate['cms-inbox']
        //        })
        //       }
        //  })

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll$.next();
        this.unsubscribeAll$.complete();
    }
}
